/* eslint-disable @typescript-eslint/no-explicit-any */
import { baseStore, globalTrackingService } from '@recruiting-solutions/rs-shared';
import { initializeApp, onLog, setLogLevel } from 'firebase/app';
import { browserLocalPersistence, browserSessionPersistence, inMemoryPersistence, getAuth, setPersistence } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore, LogLevel } from 'firebase/firestore';
import { getStorage } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { ObservableMap } from '@stencil/store';
import { ICandidateStore, StorageType } from './models';
import { AuthService } from './services';

class CandidateUi {

    async init(hostingEnvironment: string, storageType: StorageType = StorageType.BrowserTab, isFirebaseLocal = false) {
        let firebaseConfig;

        switch (hostingEnvironment) {

            case 'Production':
                firebaseConfig = {
                    apiKey: "AIzaSyCri8CpGF4DCQc79NMc5BreySAJ4QKIbDc",
                    authDomain: "csbep-75ff0.firebaseapp.com",
                    databaseURL: "https://csbep-75ff0.firebaseio.com",
                    projectId: "csbep-75ff0",
                    storageBucket: "csbep-75ff0.appspot.com",
                    messagingSenderId: "810652930634",
                    appId: "1:810652930634:web:0925fee9561446f6058cb3",
                    measurementId: "G-FN4MSQTPPL"
                };
                break;
            case 'dmProd':
                //TODO: add setting for DM PROD!!!
                break;
            case 'Staging':
            default:
                firebaseConfig = {
                    apiKey: "AIzaSyCSDkHP3iGqudjNjkj8zRvBB1QRf9yDZkc",
                    authDomain: "csbcomponents.firebaseapp.com",
                    databaseURL: "https://csbcomponents.firebaseio.com",
                    projectId: "csbcomponents",
                    storageBucket: "csbcomponents.appspot.com",
                    messagingSenderId: "994263864702",
                    appId: "1:994263864702:web:792edff32b3daf490a4f2f",
                    measurementId: "G-GNDFKPKBBS"
                };
                break;
        }
        if (firebaseConfig) {
            const firebaseApp = initializeApp(firebaseConfig);
            setLogLevel('info');
            onLog((callbackParams: { level: LogLevel; message: string; args: any[]; type: string; }) => {
                globalTrackingService.trackClientEvent('Firebase', 0, callbackParams);
            });
            const auth = getAuth();
            // TODO: Enum values are wrong! Please create a new one and use that accordingly
            switch (storageType) {
                case StorageType.BrowserTab:
                    setPersistence(auth, browserLocalPersistence);
                    break;
                case StorageType.BrowserWindow:
                    setPersistence(auth, browserSessionPersistence);
                    break;
                case StorageType.BrowserInMemory:
                default:
                    setPersistence(auth, inMemoryPersistence);
                    break;
            }

            const firestore = getFirestore();
            const fireFunctions = getFunctions(firebaseApp);
            fireFunctions.region = 'europe-west1';
            const fireStorage = getStorage();
            fireStorage.maxOperationRetryTime = 20000;
            fireStorage.maxUploadRetryTime = 100000;

            if (isFirebaseLocal) {
                // connectAuthEmulator => erstmal nicht
                connectFirestoreEmulator(firestore, 'localhost', 8080);
                // connectStorageEmulator(fireStorage, "localhost", 9199);
                connectFunctionsEmulator(fireFunctions, "localhost", 5001);
            }
        }

        const store = baseStore as ObservableMap<ICandidateStore>;

        store.onChange('user', value => {
            store.state.user = value;
            store.state.isLoggedIn = !!value || false;
            store.state.isAnon = value ? value.isAnonymous : true;
            console.log('Setting user state isAnon', store.state.isAnon);
        });

        store.onChange('currentStep', (value) => {
            if (value) {
                globalTrackingService.trackPageView(`Candidate UI Step ${value}`, 'modal_window', { job: store.state.job, "page_path": `/application/${value}` });
            }
        });
        AuthService.init();
    }
}

export const candidateUI = new CandidateUi();

